export const ADMIN = 'admin';
export const STAFF = 'staff';
export const RESIDENT = 'resident';
